import { uploadData } from "aws-amplify/storage";
import React, { useCallback, useRef, useState } from 'react';
import Footer from "../../../../components/Popup/_components/Footer";
import { getEditVessel, setEditVessel } from "../../../../contexts/EditVesselContext";
import { datetime } from "../../../../util/library/datetime";
import { VesselService } from "../../../../util/services/vessel";
import { ACTION_TYPE, AVAILABLE_TIME_TYPE, OPERATION_TYPE, VESSEL_TYPE } from "../../../../util/varibles/constants";
import { showErrorResponse } from "../../../../util/varibles/global";
import { IVessel } from "../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../util/varibles/message";
import { validateForm } from "../constants";
import styles from "../style.module.scss";

const request: {
    [id: string]: { fetch: (data: Partial<IVessel>) => Promise<IVessel>, code: NotifyCode, message: string }
} = {
    [ACTION_TYPE.CREATE]: { fetch: VesselService.add, code: NotifyCode.S1, message: 'Create' },
    [ACTION_TYPE.EDIT]: { fetch: VesselService.update, code: NotifyCode.S2, message: 'Update' }
}

interface IProps {
    editMode: ACTION_TYPE

    onSave(vessel: IVessel): void

    onClose(): void
}

const VesselSubmit: React.FC<IProps> = ({ editMode, onSave, onClose }) => {
    const [loading, setLoading] = useState(false);
    const submitting = useRef(false);
    const hook = getEditVessel();
    const setStore = setEditVessel();

    const handleSend = useCallback(async () => {
        if (submitting.current) {
            return;
        }

        const { vessel, file } = hook();
        const error = validateForm({ vessel });

        if (Object.keys(error).length > 0) {
            setStore({ error });
            return;
        }

        const {
            type,
            contact = '',
            available_time_type = AVAILABLE_TIME_TYPE.ALL,
            storages = [],
            equipments = [],
            operation_type = [],
            tank_sub_types = [],
            capacity = 0,
        } = vessel;

        if (storages.length === 0 && type !== VESSEL_TYPE.SERVICE) {
            notify.error(NotifyCode.E41)();
            return;
        }

        const data = {
            ...vessel,
            contact,
            capacity,
            operation_sub_types: [],
            available_time_type,
            operation_type: (equipments.length > 0 || tank_sub_types.length > 0)
                ? Array.from(new Set([...operation_type, OPERATION_TYPE.TREATMENT, OPERATION_TYPE.EVENT]))
                : Array.from((() => {
                    const value = new Set([...operation_type, OPERATION_TYPE.EVENT]);
                    value.delete(OPERATION_TYPE.TREATMENT);
                    return value;
                })())
        }

        submitting.current = true;
        setLoading(true);

        const { fetch, code, message = '' } = request[editMode];
        try {
            let payload: Partial<IVessel> = editMode === ACTION_TYPE.EDIT
                ? { ...vessel, ...data }
                : { ...data, image_url: '-' };

            if (file) {
                try {
                    const name = file.name.split('.');
                    name[name.length - 2] = name[name.length - 2] + '_' + datetime().format('YYYYMMDD_HHmmSSZZ');
                    const key = 'vessel/images/' + name.join('.');
                    await uploadData({ path: `public/${key}`, data: file, options: { contentType: 'image/jpeg' } }).result;
                    payload = { ...data, image_url: key };
                } catch (error) {
                    showErrorResponse('Upload file failed', error);
                    return;
                }
            }

            const rs = await fetch(payload);
            onSave(rs);
            notify.success(code)([rs.name]);
            onClose();
        } catch (error) {
            showErrorResponse(message + ' failed', error);
        } finally {
            submitting.current = false;
            setLoading(false);
        }
    }, [editMode, hook, setStore, onClose, onSave])

    return <Footer
        className={styles.footer}
        cancel={{ click: onClose }}
        ok={{
            click: handleSend,
            loading
        }}
    />
};

export default VesselSubmit;
